import { useQueryClient } from '@tanstack/react-query';

import { apiQueryClient } from 'common/query/queryClients';

export function useApiQueryClient() {
  return useQueryClient(apiQueryClient);
}
